import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bf-modal bf-modal--product-order-payment" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "display-6 mb-3" }, "Kurskarte kaufen", -1)
const _hoisted_4 = { class: "flex-shrink-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: ""
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center text-success mt-4 mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-square fa-4x" }),
  /*#__PURE__*/_createElementVNode("div", { class: "h3 ps-3" }, "Vielen Dank für deine Bestellung!")
], -1)
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "Alle Informationen wurden auch per E-Mail an dich verschickt.", -1)
const _hoisted_15 = { class: "d-flex justify-content-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepsCheckout = _resolveComponent("StepsCheckout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.shown,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.shown) = $event)),
    close: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              href: "#",
              class: "modal-close-button",
              "aria-label": "Schließen",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
            }, _hoisted_6)
          ])
        ]),
        (!_ctx.checkoutSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_StepsCheckout, {
                product: _ctx.product,
                onSuccess: _ctx.handleSuccess
              }, null, 8, ["product", "onSuccess"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                (Array.isArray(_ctx.checkoutSuccessMessage))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkoutSuccessMessage, (line) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: line }, [
                          _createElementVNode("span", null, _toDisplayString(line), 1),
                          _hoisted_12
                        ], 64))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.checkoutSuccessMessage), 1)),
                _hoisted_14
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
                }, "Schließen")
              ])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "close"]))
}